module.exports = __webpack_public_path__ + "img/example4.0cc5a484.webp";